import { createSelector } from 'reselect';

export const getById = ({ productCategoryTR }) => productCategoryTR.byId;
export const getIds = ({ productCategoryTR }) => productCategoryTR.list.allIds;
export const getProductCategoryTRList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));

export const getProductCategoryTRByProductCategoryId = (state, productCategoryId) =>
  getProductCategoryTRList(state).filter(elem => elem.ProductCategoryId === productCategoryId);

